import { Component, OnInit, Inject, Optional } from '@angular/core';
import { unavailableDayFormConfig } from '../unavailable-day.component';
import { FieldWorkerUnavailableDay } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';

/*
	TODO come up with a better approach to this. Right now I _need_
	a FormGroup type back from this dialog. Only problem is it's
	accessing values from components that implement the CVA, which
	can only be listened to through a FormControl. So I'm having to
	do some manual mapping from formcontrol to formgroup.
*/

@Component({
	templateUrl: './unavailable-day-dialog.component.html',
})
export class UnavailableDayDialogComponent extends SelfDestruct
	implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(unavailableDayFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly day: FieldWorkerUnavailableDay,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.day) {
			this.control.setValue(this.day);
		}
	}
}
